import styled from 'styled-components';

const DivThreadItem = styled.div`
  display: flex;
  flex-direction: row;
`;

export default DivThreadItem;
